import { render, staticRenderFns } from "./EmployerLayout.vue?vue&type=template&id=7856fc2e"
import script from "./EmployerLayout.vue?vue&type=script&lang=js"
export * from "./EmployerLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports